module.exports = __webpack_public_path__ + "img/menu_home.923278ce.svg";